import React, { useContext } from "react";
import I18N from "./I18N.js";
import LanguageContext from "./../contexts/languageContext.js";

const Submitted = () => {
  const { language } = useContext(LanguageContext);

  return (
    <div className="container m-auto text-center p-4">
      <div className="alert alert-success" role="alert">
        {I18N("thanks_for_submitting", language)}
      </div>
    </div>
  );
};

export default Submitted;
